import React from "react";
import { View, ViewStyle, TouchableHighlight, TextStyle } from "react-native";
import { useTheme } from "@emotion/react";
import { AppTheme } from "../../utils/theme";
import Text, { TextType } from "../Text";
import { Container } from "./styles";

type ButtonProps = {
	type?: "default" | "inactive";
	textType?: TextType;
	title: string;
	onPress: () => void;
	containerStyle?: ViewStyle;
};

const Button = ({
	type,
	textType,
	title,
	onPress,
	containerStyle,
}: ButtonProps) => {
	const {
		color: { enabled, selected, disabled, disabledText },
	}: AppTheme = useTheme() as AppTheme;
	// const { en}
	let _containerStyle: ViewStyle = {
		alignItems: "center",
		borderRadius: 10,
		paddingTop: 6,
		paddingBottom: 9,
		paddingHorizontal: 30,
		shadowColor: "#162928",
		shadowOffset: {
			width: 0,
			height: 2,
		},
		shadowRadius: 4,
		minWidth: 110,
	};
	let _highlightStyle: ViewStyle = {
		borderRadius: 10,
	};
	let _textType: TextType = textType || "ctah2";
	let textStyle: TextStyle = {
		width: "100%",
		textAlign: "center",
	};

	switch (type) {
		case "inactive":
			_containerStyle = {
				..._containerStyle,
				backgroundColor: disabled,
			};

			textStyle = {
				color: disabledText,
				...textStyle,
			};

			break;

		default:
			_containerStyle = {
				..._containerStyle,
				backgroundColor: enabled,
			};
	}

	_containerStyle = {
		..._containerStyle,
		...containerStyle,
	};

	return (
		<Container>
			<TouchableHighlight
				disabled={type === "inactive"}
				onPress={onPress}
				style={_highlightStyle}
				underlayColor={selected}>
				<View style={_containerStyle}>
					<Text type={_textType} style={textStyle}>
						{title}
					</Text>
				</View>
			</TouchableHighlight>
		</Container>
	);
};

// 073350

export default Button;
